import { render, staticRenderFns } from "./ShortcutsSection.vue?vue&type=template&id=2363c744&"
import script from "./ShortcutsSection.vue?vue&type=script&lang=ts&"
export * from "./ShortcutsSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports